import { Stack, Text } from "@mantine/core"
import { getChoicesByBinaryMask } from "../../questions/utils"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

export function AnswerMultiple({ answer, question }: IAnswerProps) {
  const {
    meta: { choices },
  } = question

  if (answer?.value == null) return <NoAnswer />

  const values = getChoicesByBinaryMask(answer.value)
  return (
    <Stack gap="xs">
      {values.map((value: number) => (
        <Text key={value} c="indigo" fz="lg">
          {choices[value].trim()}
        </Text>
      ))}
    </Stack>
  )
}
